import {BackendFAQManager} from 'components/Backend/FAQ/Manager';

export const title = 'FAQ管理';

export const orderNum = 2;
export default BackendFAQManager;
